import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { IUser } from "../../models/BaseModel";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { useForm } from 'react-hook-form';
import { Button } from "primereact/button";

const schema = yup.object({
    password: yup.string()
        .required("A password is required to proceed.")
        .min(6, "Password must be at least 6 characters long."),
});

export const Profile = () => {
    const [loading, setLoading] = useState(false);

    const toast = useRef<any>(null);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IUser>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false,
    });

    useEffect(() => {
        loadProfile();
    }, []);

    const loadProfile = async () => {
        const response = await Fetch("user/profile", "GET", null, null, null);
        if (response) {
            const data: IUser = await response.json();
            data.password = '';
            reset(data);
        }
    }

    const saveToDB = async (body: IUser) => {
        setLoading(true);
        const response = await Fetch('user/updatepassword', "POST", body, null, toast);
        if (response) {
            toast.current.show({ severity: 'success', detail: "Password changed successfully!", life: 3000 });
        }
        setLoading(false);
    }

    function onSubmit(data: any) {
        saveToDB(data);
    }

    return (
        <div className="flex align-items-center justify-content-center mt-5">
            <div className="card">
                <h5 className="mb-5">Profile : {control._formValues.name} | {control._formValues.email}</h5>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid" style={{ maxWidth: '800px' }}>
                    <JVInput required control={control} name="password" error={errors.password?.message} />
                    <div className="field col-12 md:col-6">
                        <Button loading={loading} label="Change Password" type="submit"></Button>
                    </div>
                </form>
            </div>
            <Toast ref={toast} />
        </div>
    );
}
